// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Cards */

.flexgrid {
  display: inline-block;
  display: flex;
  flex-flow: wrap;
  flex-grow: 50px;
  gap: 3.5%;
}
.flexcol{
  transition: all 0.2s ease-in-out;
 display: inline-block;
 float: left;
 width: 31%;
 text-align: center;
}





.badge-salesfunnel {
  background: #E89E3A;
  color: #fff;
}

.badge-optin {
  background: #D540BF;
  color: #fff;
}

.badge-webinar {
  background: #2ebef7;
  color: #fff;
}

.type-badge {
  min-width: 70px;
    font-size: 16px;
  font-family: Helvetica, Arial, sans-serif;
}

 @media screen and (max-width: 900px) {
  .newflexcol,.flexcol{width: 100%;}
  .cards {
    padding: 0;
  }

}

@media screen and (min-width:900px) and (max-width: 1024px) {
  .newflexcol,.flexcol{width: 46%;}

}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZ1bm5lbHMtbGF5b3V0LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsb0JBQW9COztBQUVwQjtFQUNFLHFCQUFxQjtFQUNyQixhQUFhO0VBQ2IsZUFBZTtFQUNmLGVBQWU7RUFDZixTQUFTO0FBQ1g7QUFDQTtFQUNFLGdDQUFnQztDQUNqQyxxQkFBcUI7Q0FDckIsV0FBVztDQUNYLFVBQVU7Q0FDVixrQkFBa0I7QUFDbkI7Ozs7OztBQU1BO0VBQ0UsbUJBQW1CO0VBQ25CLFdBQVc7QUFDYjs7QUFFQTtFQUNFLG1CQUFtQjtFQUNuQixXQUFXO0FBQ2I7O0FBRUE7RUFDRSxtQkFBbUI7RUFDbkIsV0FBVztBQUNiOztBQUVBO0VBQ0UsZUFBZTtJQUNiLGVBQWU7RUFDakIseUNBQXlDO0FBQzNDOztDQUVDO0VBQ0MscUJBQXFCLFdBQVcsQ0FBQztFQUNqQztJQUNFLFVBQVU7RUFDWjs7QUFFRjs7QUFFQTtFQUNFLHFCQUFxQixVQUFVLENBQUM7O0FBRWxDIiwiZmlsZSI6ImZ1bm5lbHMtbGF5b3V0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBEYXNoYm9hcmQgQ2FyZHMgKi9cblxuLmZsZXhncmlkIHtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWZsb3c6IHdyYXA7XG4gIGZsZXgtZ3JvdzogNTBweDtcbiAgZ2FwOiAzLjUlO1xufVxuLmZsZXhjb2x7XG4gIHRyYW5zaXRpb246IGFsbCAwLjJzIGVhc2UtaW4tb3V0O1xuIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiBmbG9hdDogbGVmdDtcbiB3aWR0aDogMzElO1xuIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuXG5cblxuXG4uYmFkZ2Utc2FsZXNmdW5uZWwge1xuICBiYWNrZ3JvdW5kOiAjRTg5RTNBO1xuICBjb2xvcjogI2ZmZjtcbn1cblxuLmJhZGdlLW9wdGluIHtcbiAgYmFja2dyb3VuZDogI0Q1NDBCRjtcbiAgY29sb3I6ICNmZmY7XG59XG5cbi5iYWRnZS13ZWJpbmFyIHtcbiAgYmFja2dyb3VuZDogIzJlYmVmNztcbiAgY29sb3I6ICNmZmY7XG59XG5cbi50eXBlLWJhZGdlIHtcbiAgbWluLXdpZHRoOiA3MHB4O1xuICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgZm9udC1mYW1pbHk6IEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG59XG5cbiBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA5MDBweCkge1xuICAubmV3ZmxleGNvbCwuZmxleGNvbHt3aWR0aDogMTAwJTt9XG4gIC5jYXJkcyB7XG4gICAgcGFkZGluZzogMDtcbiAgfVxuXG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6OTAwcHgpIGFuZCAobWF4LXdpZHRoOiAxMDI0cHgpIHtcbiAgLm5ld2ZsZXhjb2wsLmZsZXhjb2x7d2lkdGg6IDQ2JTt9XG5cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/wizard/funnels-layout/funnels-layout.component.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,eAAe;EACf,SAAS;AACX;AACA;EACE,gCAAgC;CACjC,qBAAqB;CACrB,WAAW;CACX,UAAU;CACV,kBAAkB;AACnB;;;;;;AAMA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;IACb,eAAe;EACjB,yCAAyC;AAC3C;;CAEC;EACC,qBAAqB,WAAW,CAAC;EACjC;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE,qBAAqB,UAAU,CAAC;;AAElC;;AAEA,gyDAAgyD","sourcesContent":["/* Dashboard Cards */\n\n.flexgrid {\n  display: inline-block;\n  display: flex;\n  flex-flow: wrap;\n  flex-grow: 50px;\n  gap: 3.5%;\n}\n.flexcol{\n  transition: all 0.2s ease-in-out;\n display: inline-block;\n float: left;\n width: 31%;\n text-align: center;\n}\n\n\n\n\n\n.badge-salesfunnel {\n  background: #E89E3A;\n  color: #fff;\n}\n\n.badge-optin {\n  background: #D540BF;\n  color: #fff;\n}\n\n.badge-webinar {\n  background: #2ebef7;\n  color: #fff;\n}\n\n.type-badge {\n  min-width: 70px;\n    font-size: 16px;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n @media screen and (max-width: 900px) {\n  .newflexcol,.flexcol{width: 100%;}\n  .cards {\n    padding: 0;\n  }\n\n}\n\n@media screen and (min-width:900px) and (max-width: 1024px) {\n  .newflexcol,.flexcol{width: 46%;}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
